/**
 * @file geneDiseaseAnnotationsFind.saga.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Feb 06, 2024 18:05
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import axiosClient from 'src/services/axiosClient.js';

import {
    geneDiseaseAnnotationsDialogSet,
} from 'src/store/actions/variant/variantPages.actions';

import {
    VARIANT_GENE_DISEASE_ANNOTATIONS_FIND_REQUEST,
    geneDiseaseAnnotationsFindSuccess,
    geneDiseaseAnnotationsFindFailure,
} from 'src/store/actions/variant/variantDb.actions';

import { dataLoadingSet } from 'src/store/actions/global.actions';
import handleSagaErrors from 'src/store/sagas/handleSagaErrors';

function callApi(payload) {
    const url = '/variant/geneDisease/annotations/find';

    const baseUrl = import.meta.env.VITE_APP_API_BASE_URL;

    const config = {
        method: 'post',
        baseURL: baseUrl,
        url,
        data: {
            geneDiseaseId: payload.geneDiseaseId,
            variantId: payload.variantId,
        },

    };

    return new Promise((resolve, reject) => {
        axiosClient(config)
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

function* searchRequestSaga(action) {

    try {
        yield put(dataLoadingSet(true));

        const resp = yield call(callApi, action.payload);
        yield put(geneDiseaseAnnotationsFindSuccess(resp.payload));
        yield put(geneDiseaseAnnotationsDialogSet(true));

    } catch (error) {
        yield put(geneDiseaseAnnotationsFindFailure(error));
        handleSagaErrors(error);
    } finally {
        yield put(dataLoadingSet(false));
    }

}

export default function* searchRequestMonitor() {
    yield takeLatest(VARIANT_GENE_DISEASE_ANNOTATIONS_FIND_REQUEST, searchRequestSaga);
}
